import { CalendarDays } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export type SimpleDateRangeOption =
  | "today"
  | "yesterday"
  | "last_7_days"
  | "last_month"
  | "this_month"
  | "all_time"
  | "custom";

interface SimpleDateRangeProps {
  dateRange: SimpleDateRangeOption;
  onDateRangeChange: (range: SimpleDateRangeOption) => void;
  customFrom?: string;
  customTo?: string;
  onCustomDateChange?: (type: "from" | "to", date: string) => void;
}

export function SimpleDateRange({
  dateRange,
  onDateRangeChange,
  customFrom,
  customTo,
  onCustomDateChange,
}: SimpleDateRangeProps) {
  return (
    <div className="flex w-full min-w-[250px] max-w-[400px] flex-col gap-3 rounded-lg border border-border bg-card p-4">
      <div className="flex items-center gap-2 text-sm font-medium text-foreground">
        <CalendarDays className="h-4 w-4 text-muted-foreground" />
        Date Range
      </div>

      <Select
        value={dateRange}
        onValueChange={(v) => onDateRangeChange(v as SimpleDateRangeOption)}
      >
        <SelectTrigger className="h-10 w-full cursor-pointer border-border bg-muted/60">
          <SelectValue placeholder="Select Period" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="today">Today</SelectItem>
          <SelectItem value="yesterday">Yesterday</SelectItem>
          <SelectItem value="last_7_days">Last 7 Days</SelectItem>
          <SelectItem value="this_month">This Month</SelectItem>
          <SelectItem value="last_month">Last Month</SelectItem>
          <SelectItem value="all_time">All Time</SelectItem>
          <SelectItem value="custom">Custom Date</SelectItem>
        </SelectContent>
      </Select>

      {dateRange === "custom" && (
        <div className="mt-1 flex animate-in items-center gap-2 fade-in slide-in-from-top-2">
          <input
            type="date"
            value={customFrom || ""}
            onChange={(e) => onCustomDateChange?.("from", e.target.value)}
            className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-none"
          />
          <span className="text-muted-foreground">-</span>
          <input
            type="date"
            value={customTo || ""}
            onChange={(e) => onCustomDateChange?.("to", e.target.value)}
            className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-none"
          />
        </div>
      )}
    </div>
  );
}
